<template>
  <b-badge variant="info" class="call-timer-wrapper">
    {{ timeStamp }}
  </b-badge>
</template>

<script>
export default {
  name: "CallTimer",
  props: {
    callTimestamp: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null,
    };
  },
  created() {
    this.startCallTimer();
  },
  computed: {
    timeStamp() {
      return this.hours > 0
        ? `${this.hours} : ${this.minutes} : ${this.seconds}`
        : `${this.minutes} : ${this.seconds}`;
    },
  },
  methods: {
    startCallTimer() {
      const callTimeStamp = Math.floor(this.callTimestamp / 1000);
      const currentTimestamp = Math.floor(Date.now() / 1000);
      let sec = currentTimestamp - callTimeStamp;

      const pad = (val) => {
        return val > 9 ? val : "0" + val;
      };

      setInterval(() => {
        this.seconds = pad(++sec % 60);
        this.minutes = pad(parseInt(sec / 60, 10) % 60);
        this.hours = pad(parseInt(sec / 3600, 10));
      }, 1000);
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.call-timer-wrapper {
  float: right;
  margin-right: 8px;
}
</style>
